import React from 'react'
import CustomTextField from './CustomTextField'
import CustomSwitchField from './CustomSwitchField'
import CustomButton from './CustomButton'
import CustomMenuField from './CustomMenuField'
import BaseField from './BaseField'
import CustomUnknown from './CustomUnknown'
import CustomTable from './CustomTable'
import { CustomDate, CustomDateTime } from '../../../shared/components/atoms/CustomDatePicker/CustomPickers'
import CustomTimeStamp from '../../../shared/components/atoms/CustomDatePicker/CustomTimeStamp'
import CustomMultipleMenu from './CustomMultipleMenu'
import CustomReference from './CustomReference'
import CustomDivider from './CustomDivider'
import CustomColor from './CustomColor'
import CustomJSON from './CustomJSON'
import CustomMedia from './CustomMedia/CustomMedia'
import CustomUserMedia from './CustomMedia/CustomUserMedia'
import Icon from '@material-ui/core/Icon'
import InputAdornment from '@material-ui/core/InputAdornment'
import CustomNumber from './CustomNumber'
import CustomVReference from './CustomVReference'
import SegmentationQuery from './SegmentationQuery'
import SurveyQuestionEnumOptions from './SurveyQuestionEnumOptions'
import PollQuestionEnumOptions from './PollQuestionEnumOptions'
import ActivationAppFlowConfig from './ActivationAppFlowConfig'
import StructuredJson from './StructuredJson'
import CustomMediaPreview from './CustomMedia/CustomMediaPreview'
import CustomRichText from './CustomRichText'

class FieldFactory {
  static getFieldByType(item) {
    let CustomSelection
    let icon

    const { type, settings: { variant } = {} } = item

    switch (type) {
      case 'text':
        icon = 'title'
        CustomSelection = CustomTextField
        break
      case 'email':
        icon = 'alternate_email'
        CustomSelection = CustomTextField
        break
      case 'password':
        icon = 'lock'
        CustomSelection = CustomTextField
        break
      case 'integer':
        CustomSelection = CustomNumber
        break
      case 'float':
        CustomSelection = CustomNumber
        break
      case 'slug':
        CustomSelection = CustomTextField
        break
      case 'date':
        icon = 'date_range'
        CustomSelection = CustomDate
        break
      case 'datetime':
        icon = 'date_range'
        CustomSelection = CustomDateTime
        break
      case 'timestamp':
        icon = 'schedule'
        CustomSelection = CustomTimeStamp
        break
      case 'boolean':
        CustomSelection = CustomSwitchField
        break
      case 'button':
        CustomSelection = CustomButton
        break
      case 'enum':
        CustomSelection = CustomMenuField
        break
      case 'multiple':
        CustomSelection = CustomMultipleMenu
        break
      case 'table':
        CustomSelection = CustomTable
        break
      case 'richtext':
        CustomSelection = CustomRichText
        break
      case 'reference':
        CustomSelection = CustomReference
        break
      case 'vreference':
        CustomSelection = CustomVReference
        break
      case 'divider':
        CustomSelection = CustomDivider
        break
      case 'json':
        switch (variant) {
          case 'segmentation':
            CustomSelection = SegmentationQuery
            break
          case 'surveyQuestionEnumOptions':
            CustomSelection = SurveyQuestionEnumOptions
            break
          case 'pollQuestionEnumOptions':
            CustomSelection = PollQuestionEnumOptions
            break
          case 'activationAppFlowConfig':
            CustomSelection = ActivationAppFlowConfig
            break
          default:
            CustomSelection = CustomJSON
        }
        break
      case 'structuredjson':
        CustomSelection = StructuredJson
        break
      case 'media':
        CustomSelection = CustomMedia
        break
      case 'usermedia':
        CustomSelection = CustomUserMedia
        break
      case 'mediapreview':
        CustomSelection = CustomMediaPreview
        break
      case 'color':
        CustomSelection = CustomColor
        break
      default:
        CustomSelection = CustomUnknown
        break
    }

    const InputProps = item.InputProps || {}

    if (icon) {
      InputProps.startAdornment = (
        <InputAdornment style={item.multiline ? { height: '1em' } : null} position="start">
          <Icon style={{ color: 'rgba(0,0,0,0.25)' }}>{icon}</Icon>
        </InputAdornment>
      )
    }

    const { api } = item

    return (
      <BaseField {...item} InputProps={InputProps} api={api}>
        <CustomSelection />
      </BaseField>
    )
  }
}

export default FieldFactory
